import { render } from "./StartNode.vue?vue&type=template&id=0ed082a5&ts=true"
import script from "./StartNode.vue?vue&type=script&lang=ts&setup=true"
export * from "./StartNode.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/connect-flow/components/flow/nodes/StartNode.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0ed082a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0ed082a5', __exports__)) {
    api.reload('0ed082a5', __exports__)
  }
  
  module.hot.accept("./StartNode.vue?vue&type=template&id=0ed082a5&ts=true", () => {
    api.rerender('0ed082a5', render)
  })

}


export default __exports__